import React from 'react';
import '../../App.css';
import './Tournaments.css';
import '../HeroSection.css';
import { Button } from '../Button';
import Footer from '../Footer';
import { useLang } from '../../i18n';
import PricingU17 from '../U17Info';

export default function U17() {
  const { t } = useLang();
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank');
    if (newWindow) newWindow.focus();
  };

  const handleButtonClick = (url) => {
    openInNewTab(url);
  };

  return (
    <React.Fragment>
      <div className='u17'>
        <div className='hero-container_tournament'>
          <h1>Slovak Youth U17</h1>
          <span className='label deadline'>{t('tournament.entryDeadline')} {t('tournament.deadlineU17')}</span>
          {/* <span className='label deadline'>Entry opens: 19th June</span> */}
          <p>{t('tournament.eventDate')}</p>

          <div className='tournaments-btns'>
            <Button 
              className='btns'
              buttonStyle='btn--outline'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('/documents/SlovakYouthU17Invitation.pdf')} /* link to external page */
            >
              {t('tournament.invitation')}
            </Button>

            <Button 
              className='btns'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('https://www.tournamentsoftware.com/tournament/67C6111E-6D6D-4398-A556-E8277671B858')} /* link to external page */
            >
              {t('tournament.register')}
            </Button>

            <Button 
              className='btns'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('https://badmintoneurope.com/web/corporate/tournament?tournament_code=6861D79B-0BD6-41AE-8926-34031E1B15A1&tournament_tab=draws')} /* link to external page */
            >
              {t('tournament.draws')}
            </Button>

            <Button 
              className='btns'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('https://badmintoneurope.com/web/corporate/tournament?tournament_code=6861D79B-0BD6-41AE-8926-34031E1B15A1&tournament_tab=entries')} /* link to external page */
            >
              {t('tournament.acceptanceList')}
            </Button>
          </div>
          

          {/* <div className='tournaments-info-wrapper'>
            <div className='tournaments-info'>
            ⓘ Provisional times can be changed subject to the number of entries.
            The final frame schedule (with the exact planned conclusion of all
            matches) shall be made at least 20 days before the start of the
            tournament and shall be published on the website.
            </div>
          </div> */}
        </div>
      </div>
      
      <PricingU17 />
      <Footer />
    </React.Fragment>
  );
}
